/*global computerSN*/
import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Card, Stack, Link, Container, Typography } from '@mui/material';
// layouts
import AuthLayout from '../layouts/AuthLayout';
// components
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import { LoginForm } from '../components/authentication/login';
import InputCompanyCode from '../components/authentication/login/InputCompanyCode'
import AuthSocial from '../components/authentication/AuthSocial';

import React, { useState, useEffect } from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { Routes, Route, useParams, useLocation, useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function CheckCompanyCode() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { computerSN } = state;

  const successCallBack = (result) => {
    const { companyAccount, companyName } = result;//公司编号 公司名称
    //跳转到登录页面
    console.log('gotoPage', 'login')
    navigate('/login', { replace: true, state: { companyAccount, companyName, computerSN } })
  }

  return (
    <RootStyle title="Login | Minimal-UI">
      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              激活操作
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>请输入激活码</Typography>
          </Stack>
          <InputCompanyCode computerSN={computerSN} successCallBack={(result) => { successCallBack(result) }} />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
